<template>
  <div class="filter-dropdown">
    <mcw-button @click="menuOpen = !menuOpen" class="filter-btn">
      <mcw-material-icon icon="filter_alt" />
    </mcw-button>

    <mcw-menu v-model="menuOpen" anchor-corner="bottom-start" class="filter-menu">
      <!-- Последние визиты -->
      <li class="mdc-list-group">
        <mcw-list-item @click="select('recent', null)">
          <mcw-material-icon icon="keyboard_arrow_right" />
          Пациенты — Последние визиты
        </mcw-list-item>
      </li>

      <!-- Пациенты по договору -->
      <li class="mdc-list-group">
        <span class="mdc-list-group__subheader">Пациенты по договору:</span>
        <div v-if="contractsLoading" class="loading">Загрузка договоров...</div>
        <div
          v-for="contract in filteredContracts"
          :key="contract.id_contract"
          class="contract-item"
        >
          <mcw-list-item
            @click.stop="select('contract', contract)"
            v-if="contract.id_contract !== 0 && !contract.archive"
            class="flex-between"
          >
            <span>
              <span class="badge-row">
                <span class="badge">ID {{ contract.id_contract }}</span>
                <span class="badge">
                  <mcw-material-icon icon="bookmark" />
                  {{ contract.N_contract }}
                </span>
                <span class="badge">
                  <mcw-material-icon icon="event" />
                  {{ contract.date_create }}
                </span>
              </span>
              <span class="v-centered ">
                <mcw-material-icon icon="keyboard_arrow_right" />
                {{ contract.name_contract }}
              </span>
            </span>
            <mcw-material-icon
              icon="expand_more"
              :class="{ rotated: expanded[contract.id_contract] }"
              @click.stop="toggleExpand(contract.id_contract)"
            />
          </mcw-list-item>

          <div v-if="expanded[contract.id_contract]" class="acts-list">
            <div v-if="loading === contract.id_contract" class="loading">Загрузка...</div>
            <mcw-list-item
              v-for="act in acts"
              :key="act.id"
              class="act-item"
              style="padding: 2px 0;"
              @click.stop="select('act', act)"
            >
              <span>
                <mcw-material-icon icon="keyboard_arrow_right" /> Акт
              </span>
              <span>
                <span class="badge">ID {{ act.id }}</span><span class="badge">От {{ act.date_add }}</span>
              </span>
            </mcw-list-item>
          </div>
        </div>
      </li>
    </mcw-menu>
  </div>
</template>

<script>
export default {
  name: 'FilterDropdown',
  props: {
    contracts: Array,
  },
  data() {
    return {
      menuOpen: false,
      expanded: {}, // { [contractId]: true }
      loading: null, // ID контракта, который сейчас грузится
      actsByContract: null,
    };
  },
  computed: {
    currentContract: {
      get() {
        return this.$store.state.contractsData.currentContract;
      },
      set(id) {
        let newId = id;
        if (id === 0) {
          newId = '0';
        }
        this.$store.commit('contractsData/SET_CURRENT_CONTRACT', `${newId}`);
      },
    },
    filteredContracts() {
      return this.contracts.filter((i) => i.id_contract !== 0 && !i.archive);
    },
    contractsLoading() {
      return this.$store.state.contractsData.processing;
    },
    acts() {
      return this.$store.getters['contractsData/getActs'];
    },
  },
  watch: {
    menuOpen(val) {
      if (!val) {
        this.loading = null;
        this.expanded = {};
      }
    },
  },
  methods: {
    async select(type, option) {
      if (!this.currentContract && type === 'act') return;
      if (type === 'recent') {
        this.currentContract = '';
        this.$store.commit('contractsData/RESET_CONTRACT_DATA');
        await this.$store.dispatch('employeesData/getLastPatients', { includeServices: false });
        return;
      }
      if (type === 'act') {
        this.loadByAct(option);
        this.menuOpen = false;
        return;
      }
      this.menuOpen = false;
      // пациенты должны запрашиваться уже по новому договору
      await this.setContract(option.id_contract);
      await this.$store.dispatch('employeesData/getLastPatients', { includeServices: false });
    },
    async loadByAct(act) {
      const params = {
        includeServices: false,
        actId: act.id,
      };
      const patients = await this.$store.dispatch('employeesData/getLastPatients', params);
      if (patients) {
        const actData = {
          val: true,
          actId: act.id,
          sum: this.getActSum(act.id),
        };
        this.$store.commit('employeesData/SET_ACT_TO_LOADED', actData);
        this.$store.commit('employeesData/IS_PATIENTS_LOADED', false);
      }
    },
    getActSum(id) {
      const act = this.$store.state.contractsData.acts.find((item) => item.id === id);
      return act?.sum_act;
    },
    async setContract(contractId) {
      if (this.currentContract !== `${contractId}`) {
        await this.$store.dispatch('contractsData/getContractsList');
        this.currentContract = `${contractId}`;
      }
    },
    async toggleExpand(contractId) {
      this.expanded = {
        ...this.expanded,
        [contractId]: !this.expanded[contractId],
      };

      if (!this.expanded[contractId]) return; // свернули — выходим

      await this.setContract(contractId);

      // Проверка: если акты по контракту уже загружены, не грузим снова
      if (this.actsByContract !== contractId || !this.acts.length) {
        this.loading = contractId;
        try {
          await this.$store.dispatch('contractsData/getActs', contractId);
          this.actsByContract = contractId;
        } catch (e) {
          console.error('Ошибка загрузки актов:', e);
        } finally {
          this.loading = null;
        }
      }
    },
  },
};
</script>

<style scoped>
.acts-list {
  padding-left: 16px;
}
.act-item {
  font-size: 0.9em;
}
.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
.loading {
  font-style: italic;
  padding: 4px 16px;
}
:deep(.mdc-list-item__text) {
  width: 100%;
  display: flex;
  justify-content: space-between !important;
}
:deep(.mdc-menu-surface) {
  overflow: scroll;
  max-height: 70vh !important;
}

.badge {
  padding: 0 6px;
  font-size: 10px;
  min-width: 18px;
  text-align: center;
  margin-right: 4px;
  margin-left: 0;
  display: inline-flex;
  align-items: center;
}
.v-centered {
  display: inline-flex;
  align-items: center;
}
.badge i {
  font-size: 16px;
}
.badge-row {
  display: flex;
}
.contract-item {
  margin-bottom: 4px;
  padding-bottom: 4px;
}
.contract-item:not(:last-child) {
  border-bottom: 1px solid #c2c2c2;
}
.filter-btn {
  min-width: 25px;
  padding: 0px;
}
.filter-menu {
  max-height: 70vh;
  overflow: scroll;
}
</style>
